<div class="modal-body">
  @if ((messageItemsAsObservable | async).length > 0) {
    <div class="mb-4">
      <rask-message-panel
        [numberOfItemsToDisplay]="2"
        [maxNumOfRows]="2"
        [items]="messageItemsAsObservable">
      </rask-message-panel>
    </div>
  }


  @for (typ of viewModel?.typer; track typ)
    {
    <div class="box">
      <div class="row">
        <rask-input class="col-6" label="Destineringsursprung" [value]="destineringsursprung"
        [readonly]="true"></rask-input>
        @if (typ.typ) {
          <rask-input class="col-6 destineringstyp" label="Destineringstyp" [value]="typ.typ"
          [readonly]="true"></rask-input>
        }
      </div>

      <div class="row">
        <div class="col-header g-0">
          Destineringsrader
        </div>
        @if (tableColumns) {
          <rask-table [data]="typ.inmatningshandelssortimentRedovisningshanvisningar"
            [columns]="tableColumns">
          </rask-table>
        }
      </div>


      <div class="row">
        <div class="col-12 g-0">
          <div class="col-header">
            Justera redovisningshänvisning
          </div>
        </div>
        @if (justeraTableColumns) {
          <rask-table [data]="typ.justeraTable" [columns]="justeraTableColumns"
            [noScroll]="true">
          </rask-table>
        }
      </div>
    </div>
  }

  <div class="row mb-4">
    @if (viewModel) {
      <div class="col-6">
        <rask-multi-selector
          aid="inputInmatningshandelssortiment"
          class="col-12"
          label="Extra inmätningshandelssortiment"
          bindLabel="namn"
          typeToSearchText="Ange minst tre tecken"
          loadingText="Laddar..."
          notFoundText="Ingen träff"
          [minTermLength]="3"
          [disabled]="!canEdit"
          [(ngModel)]="viewModel.extrainmatningshandelssortiment"
          bindValue="violId"
          [viewFormatter]="extraInmatningshandelssortimentFormatter"
          [viewSelectedFormatter]="extraInmatningshandelssortimentSelectedFormatter"
          [typeaheadFn]="searchForInmatningshandelssortiment"
          (change)="extraInmatningshandelssortimentModified()">
        </rask-multi-selector>
      </div>
    }
  </div>
  @if (isRoleSystemadmin) {
    <div class="row">
      <div class="col-6 g-0">
        <rask-checkbox class="low" aid="destineringsalternativ-aktivt" text="Destineringsalternativ aktivt"
          [(ngModel)]="boundAktivFlag"
        (ngModelChange)="addOrUpdateAktivDestineringsalternativActive()"></rask-checkbox>
      </div>
    </div>
  }
</div>

@if (isLoading) {
  <div class="loading">
  </div>
}
@if (isLoading) {
  <rask-busy-spinner size="5" class="spinner"></rask-busy-spinner>
}

<div class="modal-footer">
  <rask-button color="primary" (click)="spara()" [disabled]="!canSave()">Spara</rask-button>
  <rask-button color="secondary" (click)="close()">Stäng</rask-button>
</div>